import { connect } from 'react-redux';

// Selectors:
import { getIsMobile } from 'src/store/view/selectors';
import { setPenalizedHotelsVisibility } from 'src/routes/SearchPage/store/hotels/slice';
import { isMapViewSelector } from '../../../../store/map/selectors';
import {
  isShownPenalizedHotelsSelector,
  isVisiblePenalizedHotelsSelector,
  penalizedHotelsSelector,
  penalizedHotelsVisibleLimitSelector,
} from '../../../../store/emptyFiltration/selectors';

// Actions:
import {
  setIsVisiblePenalizedHotels,
  setShowPenalizedHotels,
} from '../../../../store/emptyFiltration/slices';

import { PenalizedHotels as Component } from './PenalizedHotels';

const mapStateToProps = (state) => ({
  hotels: penalizedHotelsSelector(state),
  isVisiblePenalizedHotels: isVisiblePenalizedHotelsSelector(state),
  isShownPenalizedHotels: isShownPenalizedHotelsSelector(state),
  isMobile: getIsMobile(state) || isMapViewSelector(state),
  visibleLimit: penalizedHotelsVisibleLimitSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  setIsVisiblePenalizedHotels: (data) =>
    dispatch(setIsVisiblePenalizedHotels(data)),
  setShowPenalizedHotels: () => dispatch(setShowPenalizedHotels()),
  setPenalizedHotelsVisibility: (data) =>
    dispatch(setPenalizedHotelsVisibility(data)),
});

const PenalizedHotels = connect(mapStateToProps, mapDispatchToProps)(Component);

export default PenalizedHotels;
